import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StaticContentComponent } from './static-content/static-content.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { LTIComponent } from './lti/lti.component';


const routes: Routes = [{ path: 'null', component: PagenotfoundComponent },
{ path: 'StaticContent', component: StaticContentComponent  },
{path: 'LTI', component: LTIComponent},
{ path: '**', component: PagenotfoundComponent }];


@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
